import { Button, Column as CdsColumn, Grid as CdsGrid } from "@carbon/react";
import { Link } from "react-router-dom";

import {
  // CdsColumn, CdsGrid,
  CurrencyDisplay,
} from "../../../../components";

export const View = ({
  title,
  subtitle,
  viewAllUrl,
  data,
  total,
  totalCurrencySymbol,
  renderRow,
}) => {
  return (
    <CdsColumn className="inline-table split-pane--left">
      <CdsGrid className="header-container">
        <CdsColumn sm={4} md={8} lg={16}>
          <h5>{title}</h5>
        </CdsColumn>

        <CdsColumn sm={4} md={8} lg={16}>
          <div className="flex-container">
            <small className="flex-box inline-table--subtitle">
              {subtitle}
            </small>

            <Link to={viewAllUrl}>View all</Link>
          </div>
        </CdsColumn>
      </CdsGrid>

      <div className="over">
        <table>
          {data.map((val, key) => {
            return (
              <tr key={key} className="small-font--table">
                {renderRow(val)}
              </tr>
            );
          })}
        </table>

        {data.length > 0 ? null : (
          <CdsColumn sm={4} md={8} lg={16}>
            <div className="flex-container">
              <small className="flex-box color-light">
                No data to display...
              </small>
            </div>
          </CdsColumn>
        )}
      </div>

      {/* <div className="flex-container total font-ctm--semibold">
        <div className="flex-box">
          <h6>Total</h6>
        </div>

        <h5>
          <CurrencyDisplay
            currency_symbol={totalCurrencySymbol}
            amount={total}
            fontSize={14}
            amountClassName="font-ctm--bold"
          />
        </h5>
      </div> */}
    </CdsColumn>
  );
};
